import React, { useState } from 'react';
import { toast } from 'sonner';

export const SettingsCard = ({ title, desc, children, testId }) => (
  <section className="bg-white border rounded-2xl p-5" data-testid={testId}>
    <h3 className="text-lg font-black uppercase text-[#00247D]" style={{ fontFamily: 'Barlow Condensed' }}>{title}</h3>
    {desc && <p className="text-xs text-slate-500 mt-0.5 mb-3">{desc}</p>}
    {children}
  </section>
);

// Wraps a settings save with busy state + error toast.
export const useSaver = (save) => {
  const [busy, setBusy] = useState(false);
  const run = async (body, msg) => {
    setBusy(true);
    try { await save(body, msg); return true; } catch (e) { toast.error(e.message); return false; } finally { setBusy(false); }
  };
  return [busy, run];
};
